import addAccountLicense from "../../users/licenses/addAccountLicense";
import uuid from 'uuid/v1'
import toggleStudentLicense from "../../users/licenses/toggleStudentLicense";
import { db } from "../../../config/firebaseconfig";
import forOwn from 'mout/object/forOwn'
import toggleLicense from "../../users/licenses/toggleLicense";

/**
 * Licenses all users of a given licenseType for a year for the assessment
 * @param {array} createdUsers the user objects that have been created
 * @param {object} school the school associated with the upload
 * @param {string} assessmentId id of the assessment associated with upload
 * @param {objec} assessment the assessment (set in db) associated with uplaod
 * @param {string} licenseType 'educator' or 'student'
 */
export default function licenseAllUsers (
  createdUsers, 
  school,  
  assessmentId, 
  assessment,
  licenseType
) {
  if (!createdUsers || createdUsers.length < 1) {
    return Promise.resolve(null)
  }
  const id = uuid()

  // Create a student or educator license for the school
  return addAccountLicense({
    startDate: Date.now(),
    endDate: Date.now() + 31556952000,
    quantity: createdUsers.length,
    licenseSet: assessmentId,
    licenseType,
    district: school.district,
    accountId: school.id,
    navName: assessment.navName,
    navCategory: assessment.navCategory,
    name: assessment.name,
    id,
  })
    .then(() => {
    // Assign all of the students to the licenses
      let licenseToggles = []
      createdUsers.forEach(user => {
        if (!user) return
        let toggle
        if (licenseType === 'student') {
          toggle = toggleStudentLicense(user.id, createdUsers, id)
        } else {
          toggle = toggleLicense(user.id, createdUsers, id)
        }
        licenseToggles.push(toggle)
      })
      return Promise.all(licenseToggles)
    })
    .then(() => {
      return db.collection('accountLicenses').doc(id).get()
    })
    .then(doc => {
      if (doc.exists) {
        const license = doc.data()
        let count = 0
        forOwn(license.licensedUsers, val => {
          if (val) count++
        })
        return db.collection('accountLicenses').doc(id).update({licensedCount: count})
      }
    })
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/licenseAllUsers.js